import { createEnum } from "@redotech/zod-util/zod-enum";

const AutoMergeDisabledReason = {
  packingSlipPrinted: "packing_slip_printed",
  packingSlipScanned: "packing_slip_scanned",
  split: "split",
  unmerged: "unmerged",
  reship: "reship",
  fulfilledFromBins: "fulfilled_from_bins",
  inventoryTransfer: "inventory_transfer",
  redoCheckoutOrder: "redo_checkout_order",
  retailerPurchaseOrder: "retailer_purchase_order",
} as const;

type AutoMergeDisabledReason =
  (typeof AutoMergeDisabledReason)[keyof typeof AutoMergeDisabledReason];

export const AutoMergeDisabledReasonSchema = createEnum(
  AutoMergeDisabledReason,
  { enumName: "AutoMergeDisabledReason" },
);
